import { render, staticRenderFns } from "./Locks.vue?vue&type=template&id=2541def3&"
import script from "./Locks.vue?vue&type=script&lang=ts&"
export * from "./Locks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports